import { IResourceComponentsProps } from "@refinedev/core";
import { AntdInferencer } from "@refinedev/inferencer/antd";
import Cw8Create from "components/cw8/Cw8Create";

export const PublicationsCreate: React.FC<IResourceComponentsProps> = () => {
    // return <AntdInferencer />;

    const resourceName :string = 'publication';
    return (
        <Cw8Create
            resourceName = {resourceName}
        ></Cw8Create>
    );

};
